import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// Element Plus dark theme vars; activated when <html class="dark">.
import 'element-plus/theme-chalk/dark/css-vars.css'
import App from './App.vue'
import router from './router'
import { useAuth } from './stores/auth'
import { useSettings } from './stores/settings'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(ElementPlus)

// Restore token + theme from localStorage before mounting.
useAuth().hydrate()
useSettings().hydrate()

app.mount('#app')
